module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-center"
  }, [_c('p', [_vm._v("Votre code:")]), _vm._v(" "), _c('strong', {
    staticClass: "binding-code"
  }, [_vm._v(_vm._s(_vm.bindingCode))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b19b6cb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/BindingCode.vue
// module id = 1580
// module chunks = 4